"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class EmptyAccountsError extends Error {
    constructor(message = 'Could not get address') {
        super(message);
        this.code = 'EMPTY_ACCOUNTS_ERROR';
    }
}
exports.default = EmptyAccountsError;
